import { html, unsafeCSS } from 'lit';
import { property } from 'lit/decorators.js';

import { DERElement } from '~/common/der-element';
import { styles as globalStyles } from '~/ui/scss/main.styles';
import { styles } from './content-icon.styles';

export class ContentIcon extends DERElement {
    static override styles = [unsafeCSS(globalStyles), unsafeCSS(styles)];

    @property({ type: String }) iconUrl?: string = '';

    override render() {
        return html`
            <div class="c-icon">
                <img src="${this.iconUrl ?? ''}" alt="Icon" />
            </div>
        `;
    }
}
